module.exports = __webpack_public_path__ + "img/menu02a.2068addb.svg";